import { useContext } from "react";
import { AuthContext } from "../context/auth";

export function useAuth() {
  const { user, updateUser, logoutUser } = useContext(AuthContext);
  return { user, updateUser, logoutUser };
}